/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Stack, Box, CircularProgress } from '@mui/material';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import Iconify from '../components/Iconify';
import PaymentDialog from '../components/payment/PaymentDialog'; // استدعاء المكون الجديد

const GetButton = styled('button')({
  boxShadow: '0px 5px 2px rgb(204, 204, 204)',
  border: 'none',
  textAlign: 'center',
});


export default function ChargeCard({ bundle ,userData }) {
  const [loading, setLoading] = useState(false);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${userInfo?.access}`,
    },
  };

  // إنشاء Payment Session جديد عبر الـ backend
  const createPaymentSession = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/api/v1/files/deposit-kashiernew/${bundle.id}/`,
        { amount: bundle.amount, currency: bundle.currency },
        config
      );
      setLoading(false);
      setIframeUrl(response.data.sessionUrl);
      setOpenDialog(true);
    } catch (error) {
      setLoading(false);
      console.error('Error creating payment session:', error);
    }
  };

  // دالة مساعدة لعرض الوصف سواء كان Array أو String
  const renderDescription = (description) => {
    if (!description) return null;

    if (Array.isArray(description)) {
      return description.map((desc, idx) => (
        <Typography key={idx} variant="body1" color="text.secondary">
          <DownloadDoneIcon sx={{ width: 20, height: 20, color: 'green' }} /> {desc}
        </Typography>
      ));
    }

    if (typeof description === 'string') {
      return description.split('\n').map((desc, idx) => (
        <Typography key={idx} variant="body2" color="text.secondary">
          <DownloadDoneIcon sx={{ width: 20, height: 20, color: 'green' }} /> {desc}
        </Typography>
      ));
    }

    return null;
  };

  return (
    <>
      <Card
        sx={{
          maxWidth: 240,
          border: 1,
          borderRadius: 1.5,
          boxShadow: 'rgba(0, 0, 0, .15 ) 0 3px 9px 0',
          mt: 1,
          '&:hover': {
            boxShadow: 'none',
            background: '#fffdf3',
            cursor: 'pointer',
          },
        }}
      >
        {/* Coins Section */}
        <Stack sx={{ width: '100%', alignItems: 'center', my: 4, bgcolor: '#007d7d' }}>
          <Stack
            sx={{
              direction: 'row',
              alignItems: 'center',
              width: '70%',
              borderBottom: 2,
              borderTop: 2,
              borderColor: 'cyan',
            }}
          >
            <Typography display="flex" variant="h3" sx={{ color: 'white', fontWeight: '600' }}>
              {bundle.coins}{' '}
              <Iconify
                style={{ color: 'white' }}
                icon="ph:coins-light"
                className="icon"
                width={30}
                height={30}
                marginTop={1}
              />
            </Typography>
          </Stack>
        </Stack>

        {/* Price Section */}
        <Stack
          sx={{
            width: '100%',
            alignItems: 'center',
            my: 2,
            bgcolor: '#f1f1f1',
            borderBottom: 1,
            borderTop: 1,
            borderColor: '#007d7d',
          }}
        >
          <Box sx={{ direction: 'row' }}>
            <Typography display="flex" variant="h3" sx={{ color: 'green' }}>
              {bundle.price}
              <Iconify
                style={{ color: '#007d7d' }}
                icon="ph:currency-dollar"
                className="icon"
                width={15}
                height={15}
                marginTop={1}
              />
            </Typography>
          </Box>
        </Stack>

        {/* Description Section */}
        <Box sx={{ py: 4, px: 2 }}>
          {renderDescription(bundle.description)}
        </Box>

        {/* Button Section */}
        <Stack sx={{ width: '100%', alignItems: 'center', mb: 5, bgcolor: '#f8f9fa' }}>
          {loading ? (
            <CircularProgress sx={{ width: '1rem', height: '1rem', color: '#006673' }} />
          ) : (
            <GetButton sx={{ width: 150, bgcolor: '#007d7d', borderRadius: 0.7 }} onClick={createPaymentSession}>
              <Typography sx={{ py: 1, color: 'cyan', borderBottom: 1, borderTop: 1, borderColor: 'cyan' }}>
                Charge Now
              </Typography>
            </GetButton>
          )}
        </Stack>
      </Card>

<PaymentDialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  iframeUrl={iframeUrl}
  userEmail={userInfo?.email}
  userName={userInfo?.name}
  userAvatar={userInfo ? `${process.env.REACT_APP_API_KEY}${userInfo?.avatarUrl}` : ''}
  currentBalance={userData?.coins ?? 0}

  bundle={bundle}
/>

    </>
  );
}

